/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import Iframe from "@nicholasadamou/react-iframe";
import classNames from "classnames";
import { routerActions } from "react-router-redux";
import { connect } from "react-redux";
import { Box } from "@ui-kit/components/index.es";
import { actions as ecomexIframeActions, selectors } from "reducers/ecomexIframe";
import Notification from "pages/_components/Notification";
import { func, shape, string, bool } from "prop-types";
import PageLoading from "pages/_components/PageLoading";
import * as config from "util/config";
import { resizableRoute } from "pages/_components/Resizable";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";

class ecomexNewRequests extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        error: shape({}),
        idTransaction: string,
        token: string,
        fetching: bool.isRequired,
        title: string,
        width: string,
        height: string,
        location: shape({}).isRequired,
        isDesktop: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        error: null,
        idTransaction: null,
        token: null,
        width: "100%",
        height: "100%",
        embeddedInV3Shell: false,
        title: "Ecomex",
    };

    constructor(props) {
        super(props);
        this.interval = null;
        const savedUrlWithHash = localStorage.getItem("ecomex-urlWithHash");

        this.state = {
            iframeUrl: savedUrlWithHash || null,
        };
    }

    componentDidMount = () => {
        const { dispatch } = this.props;
        dispatch(ecomexIframeActions.loadEnterRequestCredentials());
        this.startFetching();
        this.syncEmbeddedV3ShellLayout();
    };

    componentDidUpdate = (prevProps) => {
        const { dispatch, error, idTransaction, token, embeddedInV3Shell, isDesktop, location } = this.props;
        const { requestSuffix, typeSolicitud } = location?.state || {};
        if (idTransaction) {
            this.stopFetching();
            dispatch(routerActions.push(`/transaction/${idTransaction}`));
        }
        if (error) {
            dispatch(routerActions.push(embeddedInV3Shell ? "/v3/dashboard" : "/desktop"));
        }
        if (prevProps.token !== token && token) {
            const url = config.get("ecomex.service.url.newRequest");
            const encodedToken = encodeURIComponent(token);
            let newUrlWithHash = `${url}?hashid=${encodedToken}`;

            if (typeSolicitud === "operation") {
                const newUrl = config.get("ecomex.service.newUrl.newRequest");
                newUrlWithHash = `${newUrl}?hashid=${encodedToken}&${requestSuffix}`;
            }
            if (typeSolicitud === "informativeRegimen") {
                const newUrl = config.get("ecomex.service.newUrl.newRequestRII");
                newUrlWithHash = `${newUrl}?hashid=${encodedToken}&${requestSuffix}`;
            }

            localStorage.setItem("ecomex-urlWithHash", newUrlWithHash);
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ iframeUrl: newUrlWithHash });
        }
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell || prevProps.isDesktop !== isDesktop)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    };

    componentWillUnmount = () => {
        const { dispatch, embeddedInV3Shell } = this.props;
        this.stopFetching();
        dispatch(ecomexIframeActions.cleanUp());
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    };

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop } = this.props;
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["pages.ecomexIframe"],
            titleKey: "menu.ecomex.enterRequests",
            goBackPath: "/v3/dashboard",
        });
    };

    fetchTransactionId = () => {
        const { dispatch, token } = this.props;
        if (token !== null) {
            dispatch(ecomexIframeActions.fetchTransaction(token));
        }
    };

    startFetching = () => {
        if (!this.interval) {
            this.interval = setInterval(this.fetchTransactionId, 3000);
        }
    };

    stopFetching = () => {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    };

    render() {
        const { fetching, title, width = "100%", height = "100%", token, embeddedInV3Shell } = this.props;

        const { iframeUrl } = this.state;

        return (
            <PageLoading loading={fetching}>
                {!embeddedInV3Shell && (
                    <Notification scopeToShow="pages.ecomexIframe" notificationClassname="navbar-fixed-top" />
                )}
                {token && iframeUrl && (
                    <Box
                        w="100%"
                        px={0}
                        className={classNames(
                            "ecomex-iframe__container",
                            embeddedInV3Shell
                                ? "ecomex-iframe__container--v3-shell"
                                : "ecomex-iframe__container--legacy",
                        )}>
                        <Iframe
                            src={iframeUrl}
                            headers={{
                                "Access-Control-Allow-Origin": "*",
                                Accept: "text/plain",
                            }}
                            frameBorder="0"
                            title={title}
                            width={width}
                            height={height}
                            className="ecomex-iframe__frame"
                        />
                    </Box>
                )}
            </PageLoading>
        );
    }
}

const mapStateToProps = (state) => ({
    token: selectors.getToken(state),
    error: selectors.getError(state),
    fetching: selectors.getFetching(state),
    idTransaction: selectors.getIdTransaction(state),
});
export default connect(mapStateToProps)(resizableRoute(ecomexNewRequests));
